module.exports = __webpack_public_path__ + "img/oaFlowData199@3x.e0937a3d.png";